var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A) Icons / Tools / Progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A)-Icons-/-Tools-/-Progress",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,3.5 C20.0522847,3.5 20.5,3.94771525 20.5,4.5 L20.5,18.199 L21.5,18.1992481 C22.1213203,18.1992481 22.625,18.714289 22.625,19.3496241 C22.625,19.9426035 22.1862391,20.4307932 21.6225811,20.4932498 L21.5,20.5 L2.5,20.5 C1.87867966,20.5 1.375,19.9849591 1.375,19.3496241 C1.375,18.7566446 1.81376095,18.2684549 2.37741886,18.2059984 L2.5,18.1992481 L3.5,18.199 L3.5,12.6804511 C3.5,12.1281664 3.94771525,11.6804511 4.5,11.6804511 L7.5,11.6804511 C8.05228475,11.6804511 8.5,12.1281664 8.5,12.6804511 L8.5,18.199 L9.5,18.199 L9.5,8.59022556 C9.5,8.03794081 9.94771525,7.59022556 10.5,7.59022556 L13.5,7.59022556 C14.0522847,7.59022556 14.5,8.03794081 14.5,8.59022556 L14.5,18.199 L15.5,18.199 L15.5,4.5 C15.5,3.94771525 15.9477153,3.5 16.5,3.5 L19.5,3.5 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.0e714c08.svg";
export { ForwardRef as ReactComponent };